import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Layout from './components/Layout';
import Accounts from './components/Accounts';
import Transactions from './components/Transactions';
import BankManagement from './components/BankManagement';
import BorrowerManagement from './components/BorrowerManagement';
import BankAccountManagement from './components/BankAccountManagement';
import ProtectedRoute from './components/ProtectedRoute';
import BorrowerBankAccount from './components/BorrowerBankAccount';
import InterestRateMaintenance from './components/InterestRateMaintenance';
import LoanTypeMaintenance from './components/LoanTypeMaintenance';
import LoanTransaction from './components/LoanTransaction';
import LoanUtilization from './components/LoanUtilization';
import RepaymentSchedule from './components/RepaymentSchedule';
import DebtRepaymentByPaymentDate from './components/reports/DebtRepaymentByPaymentDate';
import DebtRepaymentByBank from './components/reports/DebtRepaymentByBank';
import DebtRepaymentBySplit from './components/reports/DebtRepaymentBySplit';
import DebtRepaymentByLoanType from './components/reports/DebtRepaymentByLoanType';
import AvailabilityPeriodReport from './components/reports/AvailabilityPeriodReport';
import HeadroomAnalysisReport from './components/reports/HeadroomAnalysisReport';
import BankTermDetailReport from './components/reports/BankTermDetailReport';
import BankTermSummaryReport from './components/reports/BankTermSummaryReport';
import AuditTrailReport from './components/reports/AuditTrailReport';
import ReportSelection from './components/reports/ReportSelection';
import ParameterSelection from './components/parameters/ParameterSelection';
import UserManagement from './components/administration/UserManagement';
import RoleManagement from './components/administration/RoleManagement';
import AuditTrailViewer from './components/administration/AuditTrailViewer';
import SystemConfiguration from './components/administration/SystemConfiguration';
import ManageProfile from './components/ManageProfile';
import ChangePassword from './components/ChangePassword';
import Notifications from './components/Notifications';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounts"
        element={
          <ProtectedRoute>
            <Layout>
              <Accounts />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions"
        element={
          <ProtectedRoute>
            <Layout>
              <Transactions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters"
        element={
          <ProtectedRoute>
            <Layout>
              <ParameterSelection />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters/bank-management"
        element={
          <ProtectedRoute>
            <Layout>
              <BankManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters/borrower-management"
        element={
          <ProtectedRoute>
            <Layout>
              <BorrowerManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters/bank-account-management"
        element={
          <ProtectedRoute>
            <Layout>
              <BankAccountManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters/borrower-bank-account"
        element={
          <ProtectedRoute>
            <Layout>
              <BorrowerBankAccount />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters/interest-rate-maintenance"
        element={
          <ProtectedRoute>
            <Layout>
              <InterestRateMaintenance />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parameters/loan-type"
        element={
          <ProtectedRoute>
            <Layout>
              <LoanTypeMaintenance />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions/loan"
        element={
          <ProtectedRoute>
            <Layout>
              <LoanTransaction />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions/loan-utilization"
        element={
          <ProtectedRoute>
            <Layout>
              <LoanUtilization />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions/repayment"
        element={
          <ProtectedRoute>
            <Layout>
              <RepaymentSchedule />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/debt-repayment-by-payment-date"
        element={
          <ProtectedRoute>
            <Layout>
              <DebtRepaymentByPaymentDate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/debt-repayment-by-bank"
        element={
          <ProtectedRoute>
            <Layout>
              <DebtRepaymentByBank />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/debt-repayment-by-split"
        element={
          <ProtectedRoute>
            <Layout>
              <DebtRepaymentBySplit />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/debt-repayment-by-loan-type"
        element={
          <ProtectedRoute>
            <Layout>
              <DebtRepaymentByLoanType />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/availability-period"
        element={
          <ProtectedRoute>
            <Layout>
              <AvailabilityPeriodReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/headroom-analysis"
        element={
          <ProtectedRoute>
            <Layout>
              <HeadroomAnalysisReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/bank-term-detail"
        element={
          <ProtectedRoute>
            <Layout>
              <BankTermDetailReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/bank-term-summary"
        element={
          <ProtectedRoute>
            <Layout>
              <BankTermSummaryReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports/audit-trail"
        element={
          <ProtectedRoute>
            <Layout>
              <AuditTrailReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute>
            <Layout>
              <ReportSelection />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration/user-management"
        element={
          <ProtectedRoute>
            <Layout>
              <UserManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration/role-management"
        element={
          <ProtectedRoute>
            <Layout>
              <RoleManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration/audit-trail-viewer"
        element={
          <ProtectedRoute>
            <Layout>
              <AuditTrailViewer />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration/system-configuration"
        element={
          <ProtectedRoute>
            <Layout>
              <SystemConfiguration />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="/profile" element={<ProtectedRoute><Layout><ManageProfile /></Layout></ProtectedRoute>} />
      <Route path="/change-password" element={<ProtectedRoute><Layout><ChangePassword /></Layout></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><Layout><Notifications /></Layout></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default App; 